import { Component, QueryList, ViewChildren } from '@angular/core';
import { AppService } from '@ui-components/services';
import { AssessmentService } from '../../services/assessment.service';
import { IProfile, IResponse } from '@interfaces/index';
import { switchMap } from 'rxjs';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { IQuestion, IQuestionResponse } from 'projects/ui-components/src/interfaces/IAssessment';
import { DomSanitizer } from '@angular/platform-browser';
import { QuestionComponent } from '../question/question.component';
import { AppRoutingService } from '@ui-components/services';
import { OktaService } from '../../../../../ui-components/src/services/okta.service';


@Component({
  selector: 'app-assessment',
  templateUrl: './assessment.component.html',
  styleUrl: './assessment.component.scss'
})
export class AssessmentComponent {

  loading = false;
  profile: IProfile | null = null;
  questions: IQuestionResponse | null = null ;
  token: string | null = null;
  @ViewChildren(QuestionComponent) components!: QueryList<QuestionComponent> ; 

  get total_answered(): number {
    const total = this.questions?.questions.filter(
      (question: IQuestion) => {
        const textAnswered = question.answer_ui_type == "Free Text" && question.user_supplied_answer_text;
        const choices = ['Free Text'].indexOf(question.answer_ui_type) < 0
        const choiceAnswered = choices && question.user_answer_ind === 1;
        if (textAnswered || choiceAnswered) {
          return true;
        }
        return false
      }
    ).length ?? 0 

    return total;
  }

  get first_unanswered_question(): number {
    return this.questions?.questions.findIndex(
      (question: IQuestion) => {
        const textNotAnswered = question.answer_ui_type == "Free Text" && !question.user_supplied_answer_text;
        const choices = ['Free Text'].indexOf(question.answer_ui_type) < 0
        const choiceNotAnswered = choices && question.user_answer_ind === 0;
        if (textNotAnswered || choiceNotAnswered) {
          return true;
        } else {
          return false
        }
      }
    ) ?? -1
  }

  constructor(
    protected app_service: AppService,
    protected appRoutingService: AppRoutingService,
    protected assessment_service: AssessmentService,
    protected router: Router,
    protected route: ActivatedRoute,
    protected oktaService: OktaService,
    protected sanitizer: DomSanitizer
  ) {}

  ngAfterViewInit() {

    setTimeout(() => {
      this.loading = true;
      this.route.params.pipe(
        switchMap(
          (params: Params) => {
            this.token = params['token'];
            return this.assessment_service.getQuestions(this.token as string)
          }
        )
      ).subscribe(
        (response: IResponse<IQuestionResponse>) => {
          if(response.code === 200) {
            this.questions = response.data;
            this.loading = false;
            setTimeout(
              () => {
  
                if(response.data.completed === true) {
                  this.router.navigate(['/assessments', 'complete'], { state: { change_innovators: this.questions?.change_innovators } })
                }
              
                if (this.first_unanswered_question >= 0) {
                  this.scrollTo(this.first_unanswered_question - 1)
                } else {
                  this.components.last.element_ref.nativeElement?.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "nearest",
                  });
                }
  
                this.manageOverlay()
              }, 0
            )
          } else {
            this.loading = false;
          }
        } 
      )
    }, 0)
  }

  complete() {
    if (this.questions?.questions.length == this.total_answered) {
      this.assessment_service.complete(this.token as string).subscribe(
        (response: IResponse<any>) => {
          this.router.navigate(['/assessments', 'complete'], { state: { change_innovators: this.questions?.change_innovators } })
        }
      )
    } else {
      this.scrollTo(this.first_unanswered_question - 1);
    }
  }

  manageOverlay() {
    const viewport_height = window.innerHeight / 2;
    let closest = this.components.first;
    closest.overlay = false;
    const lastIndex = this.components.length - 1; 

    this.app_service.on_scroll.subscribe(
      (scroll: number) => {

        if (scroll > 0) {
          this.components.map((component: QuestionComponent, index: number) => {
            if (index !== lastIndex) {
              component.overlay = true;
            }
            const current_box = component.element_ref.nativeElement.getBoundingClientRect()
            const closest_box = closest.element_ref.nativeElement.getBoundingClientRect()

            const current_center = Math.abs(
              viewport_height - (current_box.top + current_box.bottom) / 2
            );

            const saved_center = Math.abs(
              viewport_height - (closest_box.top + closest_box.bottom) / 2
            );

            if (current_center < saved_center) {
              closest = component;
            }
          });

        } else if (scroll === 0) {
          this.components.map((component: QuestionComponent, index: number) => {
            component.overlay = (index !== lastIndex);
          })
          closest = this.components.first;
        }

        closest.overlay = false;
      }
    )
  }

  scrollTo(idx: number) {
    const element = this.components.get(idx + 1)?.element_ref.nativeElement;
    element?.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "nearest",
    });
  }

}
